/* template */
<template><div :class='("coupon-price "+(numberDigit)+" "+(type))'><span class="integer">{{valueObj.integer}}</span><span class="point" v-if="(valueObj.point)">{{valueObj.point}}</span><span class="decimal">{{valueObj.decimal}}</span><div class="desc"><div class="tip">{{ tip }}</div><span class="unit">{{ couponInfo.max_benefit_capacity.unit }}</span></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6e4ad8c6"}'>
.coupon-price
  position relative
  font-size: 100rpx;
  font-family: DIN-Bold, DIN-Bold-self;
  color: #E33C2B;
  text-shadow: 1px 1px 0px #FFF;
  line-height 1
  display: flex;
  align-items: center;
  justify-content: center;
  height 100%
  &.digit-3
    .point
      margin-left 0
      margin-right -8rpx
    .integer
      letter-spacing: -4rpx;
  &.popup-result
    font-size 100rpx
    &.digit-3
      font-size 96rpx
      .tip
        margin-bottom: 12rpx
    .tip
      margin-bottom: 20rpx
  .point
    margin-left -4rpx
    margin-right -14rpx
  .desc
    display flex
    flex-direction column
  .unit
    font-size: 36rpx;
    font-family: PingFang SC;
    font-weight: 800;
    color: #E33C2B;
    text-shadow: 1px 1px 0px #FFF;
    position relative
    right: -8rpx
  .tip
    text-shadow: none
    width: 56rpx;
    height: 25rpx;
    background: #F3B651;
    border-radius: 13rpx 13rpx 13rpx 0;
    box-shadow: 1px 1px 0 0 rgba(255, 255, 255, 0.7);
    font-size: 18rpx;
    font-family: PingFang SC;
    font-weight: 300;
    color: #FFF;
    text-align center
    line-height 28rpx
    margin-bottom: 24rpx
    margin-left 8rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6e4ad8c6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon-price.mpx.js?isComponent&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./coupon-price.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6e4ad8c6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon-price6e4ad8c6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
